import OwnerAnalysisEntry, {isAnalysisOwner} from "./OwnerAnalysisEntry";
import {equivalentHitExpectation} from "../helpers/proposalResults";
import SavedTipLists from "./SavedTipLists";
import TipsSelection from "./TipsSelection";
import {tipMarket, TIP_MARKET_OPTIONS} from "../helpers/tipSelection";
import Tipphilfe from "./Tipphilfe";
import ModelSeasonComparison from "./ModelSeasonComparison";
import StatisticModel from "./StatisticModel";
import AllInOne from "./AllInOne";
import { FEATURES, hasFeatureAccess } from "../helpers/featureAccess";
import LeagueEvolution from "./LeagueEvolution";
import LeagueAnalysisEntry from "./LeagueAnalysisEntry";
import { SYSTEM_CALCULATOR_URL } from "../helpers/systemBetHandoff";
import {
  recommendStakes,
  remainingStakeLimit,
} from "../helpers/bettingStakePlan";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { tipsRequest, runTipsWorkflow } from "../helpers/tipsWorkflow";
import { searchOracleFixtures } from "../helpers/oracle";
import { fixtureTeams } from "../helpers/adminLeague";
import { formatFixtureResult } from "../helpers/fixtureResult";
import "./BettyStart.css";
const number = (value) => (Number.isFinite(value) ? value.toFixed(2) : "–");
const selectionName = (tip) =>
  ["1", "home"].includes(tip.selection)
    ? tip.homeTeam.name
    : ["2", "away"].includes(tip.selection)
    ? tip.awayTeam.name
    : tip.selection;
function Crest({ team }) {
  return team.image ? (
    <img
      className="bs-crest"
      src={team.image}
      alt=""
      onError={(e) => {
        e.currentTarget.style.visibility = "hidden";
      }}
    />
  ) : null;
}
export function TipTable({ tips, t, onConfirm, onAnalyze, selected, onSelect }) {
  const virtual = tips.some(tip=>tip.virtual);
  const proposals = virtual || tips.some(tip=>tip.kind === "saved-proposal");
  return (
    <div className="bs-table-scroll">
      <table>
        <thead>
          <tr>
            {onSelect && <th>{t("lists.select")}</th>}
            {[
              "pairing",
              "selection",
              "marketOdd",
              "fairOdd",
              "probability",
              "value",
              "expected",
              "result",
              "should",
              "betValue",
              "profit",
              "status",
            ].map((k) => (
              <th key={k} title={proposals && k === "probability" ? t("lists.expectedHitsHelp") : undefined}>{t(proposals && k === "probability" ? "lists.expectedHits" : virtual && k === "betValue" ? "lists.actualHits" : k)}</th>
            ))}
            <th />
          </tr>
        </thead>
        <tbody>
          {tips.map((tip) => (
            <tr key={tip.id}>
              {onSelect && <td><input type="checkbox" aria-label={`${t("lists.select")}: ${tip.homeTeam.name} – ${tip.awayTeam.name} ${tip.market} ${tip.selection} ${tip.line ?? ""}`} checked={selected.includes(tip.id)} onChange={e=>onSelect(tip.id,e.target.checked)}/></td>}
              <td>
                <small>
                  {new Date(tip.kickoff).toLocaleString()} · {tip.competition}
                </small>
                <span
                  className={
                    ["1", "home"].includes(tip.selection) ? "bs-highlight" : ""
                  }
                >
                  <Crest team={tip.homeTeam} />
                  {tip.homeTeam.name}
                </span>{" "}
                –{" "}
                <span
                  className={
                    ["2", "away"].includes(tip.selection) ? "bs-highlight" : ""
                  }
                >
                  <Crest team={tip.awayTeam} />
                  {tip.awayTeam.name}
                </span>
              </td>
              <td className={`bs-selection bs-${tip.selection}`}>
                {selectionName(tip)} {tip.line !== null && tip.line}
                <small>{t(`workspace.markets.${tipMarket(tip)}.name`)}</small>
              </td>
              <td>
                {number(tip.marketOdd)}
                <small>{tip.bookmaker?.name}</small>
                {tip.confirmed && (
                  <small>
                    {t("actualOdd")}: {number(tip.actualOdd)}
                  </small>
                )}
              </td>
              <td>{number(tip.fairOdd)}</td>
              <td>{(tip.virtual || tip.kind === "saved-proposal") ? (equivalentHitExpectation(tip)!==null ? number(equivalentHitExpectation(tip)*100)+" %" : "—") : Number.isFinite(tip.probability) ? number(tip.probability*100)+" %" : "—"}</td>
              <td>{number(tip.value)} %</td>
              <td>
                {number(tip.expectedGoals?.home)} /{" "}
                {number(tip.expectedGoals?.away)} /{" "}
                {number(tip.expectedGoals?.total)}
              </td>
              <td>
                {tip.result ? `${tip.result.home}:${tip.result.away}` : "–"}
              </td>
              <td>
                {number(tip.shouldGoals?.home)} /{" "}
                {number(tip.shouldGoals?.away)}
              </td>
              <td>
                {tip.virtual ? number(tip.actualHits) : tip.settlement
                  ? `${tip.settlement.betValue > 0 ? "+" : ""}${
                      tip.settlement.betValue
                    }`
                  : "–"}
              </td>
              <td>
                {tip.virtual ? <>
                  {number(tip.settlement?.profit)} {tip.virtualCurrency}
                  <small>{t("lists.stakeReturn",{stake:number(tip.virtualStake),returns:number(tip.virtualReturn)})}</small>
                </> : Number.isFinite(tip.settlement?.units) && tip.confirmed ? <>
                  {number(tip.settlement?.units)} u
                  <small>{number(tip.settlement?.profit)} €</small>
                </> : "–"}
              </td>
              <td>
                {tip.kind === "saved-proposal" ? t(tip.saved_after_kickoff ? "lists.late" : "lists.proposal") : t(tip.status)}
                {tip.saved_at && <small>{t("lists.savedAt")}: {new Date(tip.saved_at).toLocaleString()}</small>}
                {tip.settlement && <small>{t(tip.settlement.outcome)}</small>}
                {tip.virtual && !tip.settlement && <small>{t("lists."+tip.virtualStatus)}</small>}
              </td>
              <td>
                {onAnalyze && <button onClick={() => onAnalyze(tip)}>{t("analyze")}</button>}
                {onConfirm && tip.kind !== "saved-proposal" && !tip.confirmed && Date.parse(tip.kickoff) > Date.now() && (
                  <button onClick={() => onConfirm(tip)}>{t("confirm")}</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
function BettingProfile({ profile, seasons, bookmakers, t, onSave }) {
  const [draft, setDraft] = useState(profile);
  const set = (key, value) => setDraft((p) => ({ ...p, [key]: value }));
  const checks = (key, options, label) => (
    <fieldset>
      <legend>{label}</legend>
      {["leagueIds", "bookmakerIds"].includes(key) && (
        <label>
          <input
            type="checkbox"
            checked={draft[key] === null}
            onChange={(e) => set(key, e.target.checked ? null : [])}
          />
          {t("all")}
        </label>
      )}
      {options.map((option) => (
        <label key={option.id}>
          <input
            type="checkbox"
            checked={draft[key] === null || draft[key].includes(option.id)}
            onChange={(e) => {
              const current =
                draft[key] === null ? options.map((o) => o.id) : draft[key];
              set(
                key,
                e.target.checked
                  ? [...new Set([...current, option.id])]
                  : current.filter((x) => x !== option.id)
              );
            }}
          />
          {option.name}
        </label>
      ))}
    </fieldset>
  );
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSave(draft);
      }}
    >
      <div className="bs-form">
        {checks(
          "leagueIds",
          seasons.map((s) => ({ id: s.league_id, name: s.league_name })),
          t("leagues")
        )}
        <div>
          {checks("bookmakerIds", bookmakers, t("bookmakers"))}
          <p>{t("bookmakerHint")}</p>
        </div>
        <div>
          {checks(
            "markets",
            TIP_MARKET_OPTIONS.filter(m=>m.available).map(({id})=>({id,name:t(`workspace.markets.${id}.name`)})),
            t("markets")
          )}
          <p>{t("coming")}</p>
        </div>
        {checks(
          "betTypes",
          ["single", "accumulator", "system"].map((id) => ({
            id,
            name: t(id),
          })),
          t("types")
        )}
        {[
          "minOdd",
          "maxOdd",
          "threshold",
          "budget",
          "stake",
          "maxStake",
          "maxTotalStake",
          "combinationStake",
        ].map((key) => (
          <label key={key}>
            {t(key)}
            <input
              type="number"
              step="0.01"
              min={
                key === "minOdd"
                  ? 1.01
                  : key === "maxOdd"
                  ? (draft.minOdd || 1) + 0.01
                  : key === "threshold"
                  ? 0
                  : 0.01
              }
              required={[
                "minOdd",
                "threshold",
                "stake",
                "combinationStake",
              ].includes(key)}
              value={draft[key] ?? ""}
              onChange={(e) =>
                set(key, e.target.value === "" ? null : Number(e.target.value))
              }
            />
          </label>
        ))}
        {["systemMin", "systemMax"].map((key) => (
          <label key={key}>
            {t(key)}
            <span className="bs-system-pair">
              {["n", "m"].map((field) => (
                <input
                  key={field}
                  aria-label={`${t(key)} ${field}`}
                  type="number"
                  min="2"
                  max="20"
                  required
                  value={draft[key][field]}
                  onChange={(e) =>
                    set(key, { ...draft[key], [field]: Number(e.target.value) })
                  }
                />
              ))}
            </span>
          </label>
        ))}
      </div>
      <p>{t("budgetHint")}</p>
      <p>{t("systemHint")}</p>
      <p>{t("systemExample")}</p>
      <p>
        <a href={SYSTEM_CALCULATOR_URL} target="_blank" rel="noreferrer">
          {t("systemOpen")}
        </a>
      </p>
      <button className="bs-primary" type="submit">
        {t("save")}
      </button>
    </form>
  );
}
function LeaguePreview({ data, t, onAnalyze, onLeague }) {
  return (
    <>
      <div className="bs-columns">
        {["previous", "next"].map((key) => (
          <section key={key}>
            <h2>{t(key)}</h2>
            <div className="bs-table-scroll">
              <table>
                <tbody>
                  {data[key]?.fixtures?.map((f) => {
                    const [home, away] = fixtureTeams(f);
                    return (
                      <tr key={f.id}>
                        <td>
                          <small>
                            {new Date(
                              String(f.starting_at).replace(" ", "T") + "Z"
                            ).toLocaleString()}
                          </small>
                          <button
                            onClick={() =>
                              onAnalyze({
                                fixtureId: f.id,
                                leagueId: f.league_id,
                                seasonId: f.season_id,
                                roundId: f.round_id,
                              })
                            }
                          >
                            {home.name} – {away.name}
                          </button>
                        </td>
                        <td>{formatFixtureResult(f, "–")}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {!data[key] && <p>{t("noGames")}</p>}
            </div>
          </section>
        ))}
        <section>
          <h2>{t("standings")}</h2>
          <div className="bs-table-scroll">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Team</th>
                  <th>{t("played")}</th>
                  <th>{t("points")}</th>
                  <th>{t("goals")}</th>
                </tr>
              </thead>
              <tbody>
                {[...data.standings]
                  .sort((a, b) => a.position - b.position)
                  .map((row) => {
                    const detail = (code) =>
                      row.details?.find((d) => d.type?.developer_name === code)
                        ?.value ?? "–";
                    return (
                      <tr key={row.id}>
                        <td>{row.position}</td>
                        <td>{row.participant?.name || "–"}</td>
                        <td>{detail("OVERALL_MATCHES_PLAYED")}</td>
                        <td>{row.points}</td>
                        <td>
                          {detail("OVERALL_GOALS_FOR")}:
                          {detail("OVERALL_GOALS_AGAINST")}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </section>
      </div>
      <div className="bs-actions">
        <button className="bs-primary" onClick={() => onLeague(data.league)}>
          {t("fullLeague")}
        </button>
      </div>
    </>
  );
}
export function BettyStart({
  user,
  leagues = [],
  isAdmin = false,
  onDay,
  onWeek,
  onHome,
  onGames,
  onPageChange,
  onClassic,
  onAnalyze,
  onLeague,
  onUpdate,
  onStatistics,
  onSimulation,
  onSettings,
  onHelp,
  onBetting,
  onOracle,
  initialPage = "home",
}) {
  const { t: translate, i18n } = useTranslation();
  const tipsAllowed = hasFeatureAccess(FEATURES.MY_TIPS, user);
  const tipphilfeAllowed = hasFeatureAccess(FEATURES.TIPPHILFE, user);
  const statisticsAllowed = hasFeatureAccess(FEATURES.STATISTICS_MODEL, user);
  const allInOneAllowed = hasFeatureAccess(FEATURES.ALL_IN_ONE, user);
  const t = (key, values) =>
    key === "tipphilfe" ? "Tipphilfe" : key === "all-in-one"
      ? "All In One"
      : key === "model-comparison"
      ? i18n.language?.startsWith("en") ? "Model and market comparison" : "Modell- und Marktvergleich"
      : key === "statistics-model"
      ? i18n.language?.startsWith("en")
        ? "Statistics-based model"
        : "Statistikbasiertes Modell"
      : translate(`help.start.${key}`, values);
  const [ownerAnalysisOpen,setOwnerAnalysisOpen]=useState(false);
  const [page, setPage] = useState(initialPage),
    [config, setConfig] = useState(null),
    [bookmakers, setBookmakers] = useState([]),
    [period, setPeriod] = useState("current-section");
  const [selection,setSelection]=useState(null),[customRange,setCustomRange]=useState({from:"",to:""});
  const [selectedTips,setSelectedTips]=useState([]);
  const [tips, setTips] = useState([]),
    [history, setHistory] = useState([]),
    [status, setStatus] = useState("all"),
    [query, setQuery] = useState(""),
    [fixtures, setFixtures] = useState([]),
    [leagueData, setLeagueData] = useState(null);
  const [busy, setBusy] = useState(false),
    [error, setError] = useState(false),
    [notice, setNotice] = useState(""),
    [progress, setProgress] = useState(null),
    [summary, setSummary] = useState(null),
    [confirm, setConfirm] = useState(null);
  const [actualOdd, setActualOdd] = useState(""),
    [stake, setStake] = useState("1"),
    [actualBookmaker, setActualBookmaker] = useState("");
  const stop = useRef(false),
    mounted = useRef(true),
    running = useRef(false);
  useEffect(() => {
    mounted.current = true;
    setSelection(null);
    tipsRequest("betting-profile")
      .then((r) => {
        if (mounted.current) {
          setConfig(r);
          setBookmakers(r.bookmakers || []);
        }
      })
      .catch(() => {
        if (mounted.current) setError(true);
      });
    return () => {
      mounted.current = false;
      stop.current = true;
    };
  }, [user?.id]);
  async function action(fn) {
    if (running.current) return;
    running.current = true;
    setBusy(true);
    setError(false);
    setNotice("");
    try {
      await fn();
    } catch {
      if (mounted.current) setError(true);
    } finally {
      running.current = false;
      if (mounted.current) setBusy(false);
    }
  }
  function openConfirm(tip) {
    setConfirm(tip);
    setActualOdd("");
    setActualBookmaker("");
    setStake(String(config?.profile?.stake || 1));
  }
  async function generate() {
    setPage("tips");
    stop.current = false;
    await action(async () => {
      const r = await runTipsWorkflow({
        period,
        selection: selection || config?.profile,
        customRange,
        onProgress: (p) => mounted.current && setProgress(p),
        shouldStop: () => stop.current,
      });
      if (!mounted.current) return;
      setTips(r.tips);
      setSummary(r);
      setBookmakers((old) => [
        ...new Map([...old, ...r.bookmakers].map((b) => [b.id, b])).values(),
      ]);
    });
  }
  async function searchMatches() {
    setPage("search");
    await action(async () => {
      const from = new Date().toISOString().slice(0, 10),
        to = new Date(Date.now() + 7 * 86400000).toISOString().slice(0, 10);
      const r = await tipsRequest("oracle-search", { from, to });
      setFixtures(searchOracleFixtures(r.fixtures, query));
    });
  }
  function navigate(target) {
    if (
      !window.dispatchEvent(
        new Event("betty:before-navigation", { cancelable: true })
      )
    )
      return;
    if (target === "home" && onHome) { onHome(); return; }
    setPage(target);
    onPageChange?.(target);
    setError(false);
    setNotice("");

  }
  useEffect(() => {
    if (page !== "history") return;
    let cancelled=false;
    tipsRequest("tips-history").then(r=>{if(!cancelled)setHistory(r.tips);}).catch(()=>{if(!cancelled)setError(true);});
    return ()=>{cancelled=true;};
  }, [page, user?.id]);
  const shown =
    page === "history"
      ? history.filter((tip) => status === "all" || tip.status === status)
      : tips;
  const recommendation = config
    ? recommendStakes(tips, config.profile)
    : { stake: 0, total: 0 };
  return (
    <div
      className="betty-start"
      style={{
        "--bs-bg1": `url(${process.env.PUBLIC_URL || ""}/betty-start-bg.png)`,
        "--bs-bg2": `url(${process.env.PUBLIC_URL || ""}/betty-start-bg_2.png)`,
      }}
    >
      {ownerAnalysisOpen && <OwnerAnalysisEntry user={user} leagues={leagues} onClose={()=>setOwnerAnalysisOpen(false)}/>}
      <div className="bs-shade" />
      <header>
        <div>
          <small>BETTY · FOOTBALL & ANALYSIS</small>
          <h1>{page === "home" ? t("title") : t(page)}</h1>
          {page === "home" && <p>{t("intro")}</p>}
        </div>
        {!["tipphilfe", "tips", "games", "models", "analysis", "evolution", "statistics-model", "model-comparison", "all-in-one"].includes(page) && <div className="bs-actions">
          {page !== "home" && (
            <button disabled={busy} onClick={() => navigate("home")}>
              {t("home")}
            </button>
          )}
          <button disabled={busy} onClick={onGames || (()=>navigate("games"))}>
            {t("games")}
          </button>
        </div>}
      </header>
      {error && (
        <p role="alert" className="bs-message">
          {t("error")}
        </p>
      )}
      {notice && <p role="status">{notice}</p>}
      {page === "home" && (
        <div className="bs-home-groups">
          {isAnalysisOwner(user) && <button className="bs-tile bs-featured" onClick={()=>setOwnerAnalysisOpen(true)}><strong>Mein Analyse-Arbeitsplatz</strong><span>Liga → Mannschaft → Änderung → Tipp · geführter Einstieg nur für dich</span></button>}
          <button
            className="bs-tile bs-featured bs-games"
            onClick={() => navigate("games")}
          >
            <strong>{t("games")}</strong>
            <span>{t("gamesText")}</span>
          </button>
          <section>
            <h2>{t("personal")}</h2>
            <div className="bs-tiles">
              {["tips", "history", "profile"].map((key) => (
                <button
                  className="bs-tile"
                  key={key}
                  onClick={() => navigate(key)}
                >
                  <strong>{t(key)}</strong>
                  <span>{t(`${key}Text`)}</span>
                </button>
              ))}
            </div>
          </section>
          <section>
            <h2>{t("expert")}</h2>
            <button className="bs-tile" onClick={() => navigate("models")}>
              <strong>{t("models")}</strong>
              <span>{t("modelsText")}</span>
            </button>
          </section>
          <section>
            <h2>{t("management")}</h2>
            {statisticsAllowed && (
              <button
                className="bs-tile"
                onClick={() => navigate("statistics-model")}
              >
                {i18n.language?.startsWith("en")
                  ? "Statistics-based model"
                  : "Statistikbasiertes Modell"}
              </button>
            )}
            {allInOneAllowed && (
              <button
                className="bs-tile"
                onClick={() => navigate("all-in-one")}
              >
                All In One · Admin
              </button>
            )}
            <div className="bs-actions">
              {[
                ["settings", onSettings],
                ["help", onHelp],
                ["classic", onClassic],
                ...(isAdmin ? [["update", onUpdate]] : []),
              ]
                .filter(([, fn]) => fn)
                .map(([key, fn]) => (
                  <button key={key} onClick={fn}>
                    {t(key)}
                  </button>
                ))}
            </div>
          </section>
        </div>
      )}
      {page !== "home" && (
        <section className="bs-panel">
          {page === "games" && (
            <div className="bs-tiles">
              <button className="bs-tile" onClick={onDay}>
                <strong>{t("day")}</strong>
                <span>{t("dayText")}</span>
              </button>
              <button className="bs-tile" onClick={onWeek}>
                <strong>{translate("help.navigation.week")}</strong>
                <span>{translate("help.navigation.weekDescription")}</span>
              </button>
              <button className="bs-tile" onClick={() => onLeague({})}>
                <strong>{t("leagueChoice")}</strong>
                <span>{t("leagueChoiceText")}</span>
              </button>
            </div>
          )}
          {page === "models" && (
            <div className="bs-tiles">
              {(user?.user_id ?? user?.email ?? user?.id) === "paule@paule-wetten.de" && <button className="bs-tile" onClick={() => { const url = new URL(window.location.href); url.searchParams.set("view", "league-preview"); window.location.assign(url); }}><strong>Liga-Kontext · Vorschau</strong><span>Geschützter Entwurf · gespeicherte Daten · keine Änderungen</span></button>}
              {hasFeatureAccess(FEATURES.EXPERIMENTAL_FIXTURE, user) && <button className="bs-tile" onClick={onGames || (() => navigate("games"))}><strong>{i18n.language?.startsWith("en") ? "Experimental match workspace" : "Experimenteller Spiel-Arbeitsbereich"}</strong><span>{i18n.language?.startsWith("en") ? "Open a fixture, then select the experimental workspace." : "Spiel aufklappen und experimentellen Arbeitsbereich öffnen."}</span></button>}
              {[
                ...(tipphilfeAllowed ? [["tipphilfe", () => navigate("tipphilfe")]] : []),
                ...(allInOneAllowed
                  ? [["all-in-one", () => navigate("all-in-one")]]
                  : []),
                ...(statisticsAllowed ? [["statistics-model", () => navigate("statistics-model")], ["model-comparison", () => navigate("model-comparison")]] : []),
                ["analysis", () => navigate("analysis")],
                ["evolution", () => navigate("evolution")],
                ["statistics", onStatistics],
                ["simulation", onSimulation],
                ["betting", onBetting],
                ["oracle", onOracle],
              ]
                .filter(([, fn]) => fn)
                .map(([key, fn]) => (
                  <button className="bs-tile" key={key} onClick={fn}>
                    <strong>{t(key)}</strong>
                  </button>
                ))}
            </div>
          )}
          {page === "tipphilfe" && tipphilfeAllowed && <Tipphilfe user={user} />}
          {page === "model-comparison" && statisticsAllowed && <ModelSeasonComparison user={user} leagues={leagues} />}
          {page === "statistics-model" && statisticsAllowed && (
            <StatisticModel user={user} leagues={leagues} />
          )}
          {page === "all-in-one" && allInOneAllowed && (
            <AllInOne key={user?.id} user={user} leagues={leagues} />
          )}
          {page === "evolution" && <LeagueEvolution key={user?.id} />}
          {page === "analysis" && (
            <LeagueAnalysisEntry
              key={user?.id}
              leagues={leagues}
              onUpcoming={onLeague}
            />
          )}
          {page === "profile" &&
            (config ? (
              <BettingProfile
                profile={config.profile}
                seasons={config.seasons}
                bookmakers={bookmakers}
                t={t}
                onSave={(profile) =>
                  action(async () => {
                    const r = await tipsRequest("betting-profile", { profile });
                    setConfig(r);
                    setNotice(t("saved"));
                  })
                }
              />
            ) : error ? (
              <button
                onClick={() =>
                  action(async () =>
                    setConfig(await tipsRequest("betting-profile"))
                  )
                }
              >
                {t("retry")}
              </button>
            ) : (
              <p>{t("loading")}</p>
            ))}
          {page === "tips" && tipsAllowed && (
            <>
              {config ? <TipsSelection value={selection || config.profile} onChange={setSelection} seasons={config.seasons} leagues={leagues} bookmakers={bookmakers} bookmakerError={config.bookmakerError} period={period} setPeriod={setPeriod} customRange={customRange} setCustomRange={setCustomRange} busy={busy} onFind={generate} t={t} onSave={profile=>action(async()=>{const r=await tipsRequest("betting-profile",{profile});setConfig({...config,...r});setSelection(r.profile);setNotice(t("saved"));})}/> : <p>{t("loading")}</p>}
              {busy && <button onClick={()=>{stop.current=true;}}>{t("stop")}</button>}
              {progress && (
                <div role="status">
                  <strong>
                    {t(
                      progress.phase === "update"
                        ? "updateStep"
                        : progress.phase
                    )}
                  </strong>
                  <p>
                    {t("progress", {
                      ...progress,
                      remaining: Math.max(0, progress.total - progress.current),
                    })}
                  </p>
                  <progress
                    max={Math.max(1, progress.total)}
                    value={progress.current}
                  />
                </div>
              )}
              {summary && (
                <p>
                  {t("summary", {
                    total: summary.total,
                    complete: summary.complete,
                    skipped: summary.total - summary.complete,
                  })}
                </p>
              )}
              {tips.length > 0 && (
                <p>
                  {t("recommendation", {
                    stake: number(recommendation.stake),
                    total: number(recommendation.total),
                  })}
                </p>
              )}
            </>
          )}
          {page === "history" && (
            <div className="bs-actions">
              <label>
                {t("status")}
                <select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  {["all", "suggested", "confirmed", "settled"].map((s) => (
                    <option key={s} value={s}>
                      {t(s)}
                    </option>
                  ))}
                </select>
              </label>
              <button
                disabled={busy}
                onClick={() =>
                  action(async () => {
                    const rows = [];
                    for (const [i, tip] of history.entries()) {
                      setProgress({
                        phase: "update",
                        current: i,
                        total: history.length,
                      });
                      try {
                        rows.push(
                          (await tipsRequest("tips-settle", { id: tip.id })).tip
                        );
                      } catch {
                        rows.push(tip);
                        setError(true);
                      }
                    }
                    setHistory(rows);
                    setProgress(null);
                  })
                }
              >
                {t("refresh")}
              </button>
              {busy && progress && (
                <span>
                  {t("progress", {
                    ...progress,
                    remaining: progress.total - progress.current,
                  })}
                </span>
              )}
            </div>
          )}
          {["tips", "history"].includes(page) && tipsAllowed && <SavedTipLists tips={shown} selected={selectedTips} setSelected={setSelectedTips} onRestore={setTips} userId={user?.id} results={page === "history"} t={t} renderList={rows=><TipTable tips={rows} t={t} onAnalyze={onAnalyze}/>}/>}
          {["tips", "history"].includes(page) &&
            (shown.length ? (
              <TipTable
                tips={shown}
                selected={selectedTips}
                onSelect={(id,checked)=>setSelectedTips(old=>checked?[...new Set([...old,id])]:old.filter(x=>x!==id))}
                t={t}
                onConfirm={openConfirm}
                onAnalyze={onAnalyze}
              />
            ) : (
              !busy && !error && (page === "history" || (summary && !config.bookmakerError && !summary.failures?.length)) && <p>{t("empty")}</p>
            ))}
          {page === "search" && (
            <>
              <form
                className="bs-actions"
                onSubmit={(e) => {
                  e.preventDefault();
                  searchMatches();
                }}
              >
                <label>
                  {t("query")}
                  <input
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Werder"
                    required
                  />
                </label>
                <button disabled={busy}>{t("find")}</button>
              </form>
              <div className="bs-table-scroll">
                <table>
                  <tbody>
                    {fixtures.map((f) => (
                      <tr key={f.id}>
                        <td>{new Date(f.kickoff).toLocaleString()}</td>
                        <td>{f.league}</td>
                        <td>
                          <button
                            onClick={() => onAnalyze({ ...f, fixtureId: f.id })}
                          >
                            {f.home.name} – {f.away.name}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
          {page === "league" && (
            <>
              <label>
                {t("league")}
                <select
                  disabled={busy}
                  value={leagueData?.league.league_id || ""}
                  onChange={(e) => {
                    const league = config?.seasons.find(
                      (s) => Number(s.league_id) === Number(e.target.value)
                    );
                    if (league) onLeague(league);
                  }}
                >
                  <option value="">{t("choose")}</option>
                  {config?.seasons.map((s) => (
                    <option key={s.league_id} value={s.league_id}>
                      {s.league_name}
                    </option>
                  ))}
                </select>
              </label>
              {leagueData && (
                <LeaguePreview
                  data={leagueData}
                  t={t}
                  onAnalyze={onAnalyze}
                  onLeague={onLeague}
                />
              )}
            </>
          )}
          {page === "tips" && summary?.failures.length > 0 && isAdmin && (
            <details>
              <summary>{t("details")}</summary>
              <pre>{JSON.stringify(summary.failures, null, 2)}</pre>
            </details>
          )}
        </section>
      )}
      {confirm && (
        <form
          className="bs-panel bs-confirm"
          role="dialog"
          aria-modal="true"
          aria-label={t("confirm")}
          onSubmit={(e) => {
            e.preventDefault();
            action(async () => {
              const r = await tipsRequest("tips-confirm", {
                id: confirm.id,
                actualOdd: Number(actualOdd),
                selectionIds: [
                  confirm.id,
                  ...tips
                    .filter((tip) => tip.id !== confirm.id && tip.confirmed)
                    .map((tip) => tip.id),
                ],
                stake: Number(stake),
                bookmaker: actualBookmaker,
              });
              const replace = (rows) =>
                rows.map((tip) => (tip.id === r.tip.id ? r.tip : tip));
              setTips(replace);
              setHistory(replace);
              setConfirm(null);
            });
          }}
        >
          <h2>{t("confirm")}</h2>
          <p>
            {selectionName(confirm)} {confirm.line} · {confirm.homeTeam.name} –{" "}
            {confirm.awayTeam.name}
          </p>
          <p>{t("confirmHint")}</p>
          <label>
            {t("actualOdd")}
            <input
              autoFocus
              required
              type="number"
              min="1.01"
              step="0.01"
              value={actualOdd}
              onChange={(e) => setActualOdd(e.target.value)}
            />
          </label>
          <label>
            {t("actualBookmaker")}
            <input
              required
              maxLength={120}
              value={actualBookmaker}
              onChange={(e) => setActualBookmaker(e.target.value)}
            />
          </label>
          <label>
            {t("stake")}
            <input
              required
              min="0.01"
              max={
                config &&
                Number.isFinite(remainingStakeLimit(config.profile, tips))
                  ? remainingStakeLimit(config.profile, tips)
                  : undefined
              }
              step="0.01"
              type="number"
              value={stake}
              onChange={(e) => setStake(e.target.value)}
            />
          </label>
          <div className="bs-actions">
            <button disabled={busy} type="submit" className="bs-primary">
              {t("confirm")}
            </button>
            <button
              type="button"
              disabled={busy}
              onClick={() => setConfirm(null)}
            >
              {t("cancel")}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}
